import Visual from '../../components/Visual'

class HowItWorks {
  constructor() {
    this.visuals = Array.from(document.querySelectorAll('.visual')).map(el => new Visual(el))
  }
}

export default HowItWorks
